const RadioButton = ({ name, value, checked, onChange, label }) => {
    return (
        <label className="flex items-center space-x-2 cursor-pointer">
            <input
                type="radio"
                name={name}
                value={value}
                checked={checked}
                onChange={onChange}
                className="peer sr-only" 
            />
            <div className="w-5 h-5 rounded-full border-2 border-white flex items-center justify-center peer-checked:border-white">
                <div className={`w-2.5 h-2.5 rounded-full transition-transform duration-150 ${checked ? 'scale-100 bg-white' : 'scale-0'}`} />
            </div>
            <span>{label}</span>
        </label>
    );
};


export default RadioButton;
